import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsMetrics(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRICS,
		options
	)
}
function _getRegulationsMetricPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_PREVIEW,
		options
	)
}
function _getRegulationsMetricPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_POPUP,
		options
	)
}

function _createRegulationsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].CREATE_REGULATIONS_METRIC,
		options
	)
}

function _getRegulationsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC,
		options
	)
}

function _patchRegulationsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PATCH_REGULATIONS_METRIC,
		options
	)
}

function _putRegulationsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PUT_REGULATIONS_METRIC,
		options
	)
}

function _deleteRegulationsMetric(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_METRICS,
		ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].DELETE_REGULATIONS_METRIC,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRICS]: _getRegulationsMetrics,

	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_PREVIEW]: _getRegulationsMetricPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_POPUP]: _getRegulationsMetricPopup,

	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].CREATE_REGULATIONS_METRIC]: _createRegulationsMetric,
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC]: _getRegulationsMetric,
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PATCH_REGULATIONS_METRIC]: _patchRegulationsMetric,
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PUT_REGULATIONS_METRIC]: _putRegulationsMetric,
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].DELETE_REGULATIONS_METRIC]: _deleteRegulationsMetric,
}